import EmailList from "./email_list";
import ContactForms from "./contact_forms";
import Feedback from "./feedback";

function Contacts() {
  return (
    <div className="m-4">
      <div className="text-lg font-semibold">Contacts</div>
      <div className="flex gap-2">
        <EmailList />
        <div className="flex flex-col gap-2">
          <ContactForms />
          <Feedback />
        </div>
      </div>
    </div>
  );
}

export default Contacts;
